import React from 'react';
import MunicipalityLogo from '../../assets/logo-dimou.png'

const Banner = () => {
    return (
        <div>
            <img src={MunicipalityLogo} alt="Logo Δήμου" style={{ maxWidth: '20%', height: '20%' }} />
        </div>
    );
};

export default Banner;
